import { ActionIcon } from '@mantine/core'
import { useStations } from '../_stations'
import { useI18n } from '../_i18n'

const GOLD = '#FFD966'

// Star toggle for a favoritable thing's state, placed next to its title.
// Filled gold when favorited (an attention cue), outline/muted otherwise.
//
// `item` is { id, name } for a tide or current station and { id, name, slug }
// for a chart — the prop is not called `station` any more because charts use
// this too, and the identical affordance in the identical place is the point
// (Randy: charts should work "the exact same way").
export default function FavoriteButton({ kind, item }) {
  const { isFavorite, toggleFavorite } = useStations()
  const { t } = useI18n()
  const active = isFavorite(kind, item.id)
  const label = active ? t('remove_from_favorites') : t('add_to_favorites')
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      size="lg"
      onClick={() => toggleFavorite(kind, item)}
      title={label}
      aria-label={label}
      aria-pressed={active}
    >
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill={active ? GOLD : 'none'}
        stroke={active ? GOLD : 'currentColor'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </ActionIcon>
  )
}
